import props from "prop-types"

export function getMemberIcon(memberData : any) {
  var isMale = true;
  var age = 40;
  var imagePath = '';
  if (memberData.gender)
    isMale = memberData.gender.toLowerCase() === "male";
  if (memberData.age)
    age = memberData.age;
  if (age > 0 && age <= 6) {
    isMale ? imagePath = '/images/memberSelection/1-6-Male.svg'
    : imagePath = '/images/memberSelection/1-6-Female.svg';
  } else if (age > 6 && age <= 16) {
    isMale ? imagePath = '/images/memberSelection/7-16-Male.svg'
    : imagePath = '/images/memberSelection/7-16-Female.svg';
  } else if (age > 16 && age <= 35) {
    isMale ? imagePath = '/images/memberSelection/17-35-Male.svg'
    : imagePath = '/images/memberSelection/17-35-Female.svg';
  } else if (age > 35 && age <= 50) {
    isMale ? imagePath = '/images/memberSelection/36-50-Male.svg'
    : imagePath = '/images/memberSelection/36-50-Female.svg';
  } else if (age > 50) {
    isMale ? imagePath = '/images/memberSelection/50+Male.svg'
    : imagePath = '/images/memberSelection/50+Female.svg';
  } else
    imagePath = '/images/memberSelection/36-50-Male.svg';
  return imagePath;
}